import React from 'react';
import strings from 'strings';
import * as styles from './AvgPriceBanner.scss';

import { Banner } from '../Banner';

const AvgPriceBanner = (props) => {
  const {
    avgPriceUrl,
    closeBanner,
    imageUrl,
  } = props;

  return (
    <Banner
      url={avgPriceUrl}
      closeBanner={closeBanner}
      primaryText={strings.avgPriceBannerPrimary}
      buttonText={strings.avgPriceBannerBtn}
      imageUrl={imageUrl}
      imageAlt="avg-price-image"
      className={styles.avgPriceBanner}
    />
  );
};

export default AvgPriceBanner;
